import React from 'react';
import { Link } from 'react-router';
import './style.css';
import BillingReminder from 'components/BillingReminder';

class SubNav extends React.Component {
  render() {
    const path = this.props.location.pathname;
    const { user, subscriptionExpired } = this.props;
    return (
      <div className="mk-sub-navbar">
        <div className="container">
          <ul className="mk-subnav">
            {this.props.links.map((link, index) => {
              const subNavPrefix = link.href
                .split('/')
                .slice(0, 3)
                .join('/');
              return (
                <li
                  key={index}
                  className={`sub-nav-li ${
                    path.startsWith(subNavPrefix) ? 'active' : ''
                  }`}
                >
                  {this._isUrl(link.href) ? (
                    <a href={link.href}>
                      {link.label}
                      {link.isNew ? (
                        <span className="box_center">NEW</span>
                      ) : (
                        ''
                      )}{' '}
                    </a>
                  ) : (
                    <Link to={link.href}>
                      {link.label}{' '}
                      {link.isNew ? (
                        <span className="box_center">NEW</span>
                      ) : (
                        ''
                      )}
                    </Link>
                  )}
                </li>
              );
            })}
            <div className="visible-lg visible-md">
              <BillingReminder
                user={user}
                subscriptionExpired={subscriptionExpired}
              />
            </div>
          </ul>
        </div>
      </div>
    );
  }

  _isUrl = url => {
    return url.indexOf('http') >= 0;
  };
}

export default SubNav;
